import {
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  InputAdornment,
  MenuItem,
  Snackbar,
  TextField,
  Backdrop, CircularProgress, DialogActions, Button, Box, Typography, FormGroup,
  IconButton, ListItemAvatar, Avatar, ListItemText, ListItemSecondaryAction,
  List, ListItem, DialogContent, DialogTitle, Dialog, FormControlLabel, Checkbox,
  TableContainer, Table, TableBody, TableRow, TableCell, TableHead, CardActions,Switch,DialogContentText
} from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import { makeStyles, ThemeProvider, useTheme } from '@material-ui/styles';
import moment from 'moment';
// import 'moment/locale/vi'
import 'moment/min/locales';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer, Views } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import EventNoteIcon from '@material-ui/icons/EventNote';
import { getUser } from 'src/utils/Common';
import { GoogleMap, LoadScript, Marker, Polyline, TrafficLayer } from '@react-google-maps/api';
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import { setTask } from '../../store/actions/taskActions';
import PinDropIcon from '@material-ui/icons/PinDrop';
import MobileStepper from "@material-ui/core/MobileStepper";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import CallMadeIcon from '@material-ui/icons/CallMade';
import FileCopyIcon from '@material-ui/icons/FileCopy';


const AnyReactComponent = ({ text }) => <div>{text}</div>;

const useStyles = makeStyles(theme => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  cardsMax: {
    maxHeight: 750,
    minHeight: 750
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  header: {
    display: "flex",
    alignItems: "center",
    height: 50,
    paddingLeft: theme.spacing(4)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
}));
const siyah = '#424242';
const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});

const localeMap = {
  tr: trLocale
};

const containerStyle = {
  width: '100%',
  height: '700px'
};

function Scheduling({ className, ReceiptNo, readonly, tasks, setTask }) {
  const { t } = useTranslation('work_order');
  const messages = {
    allDay: t('lblDaytime'),
    previous: t('lblPrevious'),
    next: t('lblNext'),
    today: t('lblToday'),
    month: t('lblMonth'),
    week: t('lblWeek'),
    day: t('lblDay'),
    agenda: t('lblAgenda'),
    date: t('lblDate'),
    time: t('lblTime'),
    event: t('lblEvent'), // Or anything you want
    showMore: total => `+ ${total}` + t('lblAdditionalEvents')
  }


  const classes = useStyles();
  const SessionUser = getUser();
  const UserId = SessionUser.TechnicianId;
  const locale = localStorage.getItem('i18nextLng');
  if (locale === 'vn') {
    moment.locale('vi');
  } else {
    moment.locale(locale);
  }
  const localizer = momentLocalizer(moment);
  const [ServiceShopData, setServiceShopData] = useState([]);
  const [dense, setDense] = React.useState(false);
  const [EmployeeData, setEmployeeData] = useState([]);
  const [ServiceShopId, setServiceShopId] = useState(0);
  const [ConsumerAddressId, setConsumerAddressId] = useState(0);
  const [AllAgent, setAllAgent] = useState(false);
  const [SchedulingPopup, setSchedulingPopup] = useState(false);
  const [EmployeeId, setEmployeeId] = useState(0);
  const [AppointmentDateEvent, setAppointmentDateEvent] = useState([]);
  const [SchedulingData, setSchedulingData] = useState([]);
  const [TechnicianMapData, setTechnicianMapData] = useState([]);
  const [DisabledControl, setDisabledControl] = useState(false);
  const [DisabledCanSeeAllagents, setDisabledCanSeeAllagents] = useState(false);
  const [ServiceShopSelected, setServiceShopSelected] = useState(null);
  const [SchedulingMapPopup, setSchedulingMapPopup] = useState(false);
  const [MapDate, setMapDate] = useState('');
  const [Loading, setLoading] = useState(true);
  const [ServiceShopCapacitySelected, setServiceShopCapacitySelected] = useState(true);
  var SonlandirData = tasks.tasks.filter(d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo));
  const [TechnicianSchedulingData, setTechnicianSchedulingData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [Uyari1, setUyari1] = React.useState('');
  const [uyariTip, setUyariTip] = useState('success');
  const [copySnackbarOpen, setCopySnackbarOpen] = React.useState(false);
  const [copySnackbarMessage, setCopySnackbarMessage] = React.useState('');
  const [copySnackbarType, setCopySnackbarType] = React.useState('success');

  const today = new Date()

  const [noAppointmentDate, setNoAppointmentDate] = useState(false)

  useEffect(() => {
    if (parseInt(SessionUser.Role) === 1 || parseInt(SessionUser.Role) === 2) {
      setDisabledControl(true);
    }
  }, [SessionUser.Role]);

  useEffect(() => {
    if (AppointmentDateEvent.length === 0 && SonlandirData[0]?.AppointmentDate != undefined && SonlandirData[0]?.AppointmentEndDate != undefined) {
      // changeAppointment(SonlandirData[0].AppointmentDate, SonlandirData[0].AppointmentEndDate)
    }
  }, [AppointmentDateEvent]);
  useEffect(() => {
    AuthenticateCanSeeAllAgents(UserId);
  }, []);

  const GetAllSchedulingServiceShop = ( ) => {
    setServiceShopData([]);
    setServiceShopId('');
    axios
      .get(`/GetSchedulingServiceShop/${0}/${0}/${0}/${0}`)
      .then(response => {
        if (response.data.length > 0) {
          var ServiceShopList = response.data;
          setServiceShopData(ServiceShopList);
          if (ServiceShopList.length === 1 && parseInt(SonlandirData[0]?.ServiceShopId || 0) < 1) {
            // setServiceShopId(ServiceShopList[0].Id);
            GetSchedulingEmployee(ServiceShopList[0].Id);
            return;
          }

          if (parseInt(SonlandirData[0]?.ServiceShopId || 0) > 0) {
            setServiceShopId(SonlandirData[0]?.ServiceShopId);
            var ServisData = ServiceShopList.filter(x => x.Id === SonlandirData[0]?.ServiceShopId);
            setServiceShopSelected(ServisData[0]);
            GetSchedulingEmployee(SonlandirData[0]?.ServiceShopId);
          }

        }
      })
      .catch(error => { });
  };


  const GetSchedulingServiceShop = (ConsumerId, AddressId) => {
    setServiceShopData([]);
    setServiceShopId('');
    axios
      .get(`/GetSchedulingServiceShop/${ConsumerId}/${AddressId}/${ReceiptNo}/${SessionUser.Role}`)
      .then(response => {
        if (response.data.length > 0) {
          var ServiceShopList = response.data;
          setServiceShopData(ServiceShopList);
          if (ServiceShopList.length === 1 && parseInt(SonlandirData[0]?.ServiceShopId || 0) < 1) {
            // setServiceShopId(ServiceShopList[0].Id);
            GetSchedulingEmployee(ServiceShopList[0].Id);
            return;
          }

          if (parseInt(SonlandirData[0]?.ServiceShopId || 0) > 0) {
            setServiceShopId(SonlandirData[0]?.ServiceShopId);
            var ServisData = ServiceShopList.filter(x => x.Id === SonlandirData[0]?.ServiceShopId);
            setServiceShopSelected(ServisData[0]);
            GetSchedulingEmployee(SonlandirData[0]?.ServiceShopId);
          }

        }
      })
      .catch(error => { });
  };

  const AuthenticateCanSeeAllAgents = (UserId) => {
    setServiceShopData([]);
    setServiceShopId('');
    axios
      .get(`/AuthenticateCanSeeAllAgents/${UserId}`)
      .then(response => {
        var ServiceShopList = response.data;
        setDisabledCanSeeAllagents(ServiceShopList);
        return;
      })
      .catch(error => { });
  };

  const GetSchedulingEmployee = ServiceShopId => {
    setEmployeeData([]);
    setEmployeeId('');
    axios
      .get(`/GetSchedulingEmployee/${ServiceShopId}`)
      .then(response => {
        if (response.data.length > 0) {
          var EmloyeeList = response.data;
          setEmployeeData(EmloyeeList);
          if (SonlandirData[0]?.EmployeeId || 0 > 0) {
            // let job = SonlandirData[0];
            // job = {
            //   ...job,
            //   EmployeeId: SonlandirData[0]?.EmployeeId,
            //   ServiceShopId: ServiceShopId
            // };
            // setTask(job);
            setEmployeeId(SonlandirData[0]?.EmployeeId);
          } else {
            // let job = SonlandirData[0];
            // job = {
            //   ...job,
            //   EmployeeId: EmloyeeList[0]?.Id,
            //   ServiceShopId: ServiceShopId
            // };
            // setTask(job);
            // setEmployeeId(EmloyeeList[0]?.Id);
          }

          const TechnicianData = response.data.filter(
            d => parseInt(d.Id) === parseInt(SonlandirData[0].EmployeeId)
          );
          const AppointmentH = [];
          TechnicianData[0].Appointment.forEach(item => {
            const App1 = new Date(item.start);
            const App2 = new Date(item.end);

            AppointmentH.push({
              title: item.title,
              start: App1,
              end: App2,
              MobileStatusId: item.MobileStatusId
            });
          });

          if (AppointmentH.length > 0) {
            setAppointmentDateEvent(AppointmentH);
          }
        } else {
          let job = SonlandirData[0];
          job = {
            ...job,
            ServiceShopId: ServiceShopId
          };
          setTask(job);
        }

      })
      .catch(error => { });
  };

  useEffect(() => {
    if (SonlandirData[0]?.ConsumerId && SonlandirData[0]?.ConsumerAddressId) {
      GetSchedulingServiceShop(
        SonlandirData[0].ConsumerId,
        SonlandirData[0].ConsumerAddressId
      );
      setConsumerAddressId(SonlandirData[0].ConsumerAddressId);
    }

  }, [SonlandirData[0]?.ConsumerId]);

  const handleChangeWorkOrderAddressId = event => {
    let job = SonlandirData[0];
    job = {
      ...job,
      ConsumerAddressId: event.target.value
    };
    setTask(job);
    setConsumerAddressId(event.target.value);
    GetSchedulingServiceShop(SonlandirData[0].ConsumerId, event.target.value);
  };

  const selectedAddress = SonlandirData[0]?.Addresses?.find(
    p => parseInt(p.AddressId) === parseInt(ConsumerAddressId)
  );
  const selectedAddressText = selectedAddress?.Address
    ? `${selectedAddress.Address}${selectedAddress.PrimaryAddress === true ? ` - ${t('lblPrimary')}` : ''}`
    : '';

  const handleCopyAddress = event => {
    event.preventDefault();
    event.stopPropagation();

    if (!selectedAddressText || !navigator.clipboard?.writeText) {
      setCopySnackbarMessage('Address copy failed');
      setCopySnackbarType('error');
      setCopySnackbarOpen(true);
      return;
    }

    navigator.clipboard.writeText(selectedAddressText)
      .then(() => {
        setCopySnackbarMessage('Address copied');
        setCopySnackbarType('success');
        setCopySnackbarOpen(true);
      })
      .catch(() => {
        setCopySnackbarMessage('Address copy failed');
        setCopySnackbarType('error');
        setCopySnackbarOpen(true);
      });
  };

  const handleCopyMouseDown = event => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleChangeServiceShopId = value => {
    setServiceShopSelected(value);
    setServiceShopId(value.Id);
    GetSchedulingEmployee(value.Id);
    let job = SonlandirData[0];
    job = {
      ...job,
      ServiceShopId: value.Id
    };
    setTask(job);
  };
  const handleChangeEmployeeId = value => {
    const newEmployeeId = value ? value.Id : '';
    setEmployeeId(newEmployeeId);
    if (!value) {
      return;
    }
    const TechnicianData = EmployeeData.filter(
      d => parseInt(d.Id) === parseInt(newEmployeeId)
    );
    const AppointmentH = [];
    TechnicianData[0].Appointment.forEach(item => {
      const App1 = new Date(item.start);
      const App2 = new Date(item.end);
      AppointmentH.push({
        title: item.title,
        start: App1,
        end: App2,
        MobileStatusId: item.MobileStatusId
      });
    });
    setAppointmentDateEvent(AppointmentH);
    let job = SonlandirData[0];
    job = {
      ...job,
      EmployeeId: newEmployeeId
    };
    setTask(job);
  };

  const changeAppointmentDate = ({ start, end, action }) => {
    changeAppointment(start, end)
  }

  function changeAppointment(start, end) {
    if (!noAppointmentDate) {
      const DateValue = moment(start).format('YYYY.MM.DD HH:mm');
      const EndDateValue = moment(end).format('YYYY.MM.DD HH:mm')
      let job = SonlandirData[0];
      job = {
        ...job,
        AppointmentDate: DateValue,
        AppointmentEndDate: EndDateValue
      };
      const AppointmentH = [...AppointmentDateEvent];
      const filteredIndex = AppointmentH.findIndex(
        x => x.title === `WO:${ReceiptNo}`
      );
      if (filteredIndex > -1) {
        AppointmentH.splice(filteredIndex, 1);
      }
      AppointmentH.push({
        title: `WO:${ReceiptNo}`,
        start: new Date(DateValue),
        end: new Date(EndDateValue)
      });
      setAppointmentDateEvent(AppointmentH);
      setTask(job);
    }
  }

  const setPreferredDate = value => {
    const DateValue = moment(value).format('YYYY.MM.DD HH:mm');
    let job = SonlandirData[0];
    job = {
      ...job,
      PreferredDate: DateValue,
    };
    setTask(job);
  };


  const setAppointmentData = value => {

    const DateValue = moment(value).format('YYYY.MM.DD HH:mm');
    const EndDateValue = moment(value).add(2, 'hours').format('YYYY.MM.DD HH:mm');
    let job = SonlandirData[0];
    job = {
      ...job,
      AppointmentDate: DateValue,
      AppointmentEndDate: EndDateValue
    };
    const AppointmentH = [...AppointmentDateEvent];
    const filteredIndex = AppointmentH.findIndex(
      x => x.title === `WO:${ReceiptNo}`
    );
    if (filteredIndex > -1) {
      AppointmentH.splice(filteredIndex, 1);
    }

    AppointmentH.push({
      title: `WO:${ReceiptNo}`,
      start: new Date(DateValue),
      end: new Date(EndDateValue)
    });

    setAppointmentDateEvent(AppointmentH);
    setTask(job);
  };

  const setAppointmentEndData = value => {
    const DateValue = moment(value).format('YYYY.MM.DD HH:mm');
    let job = SonlandirData[0];
    job = {
      ...job,
      AppointmentEndDate: DateValue
    };
    const AppointmentH = [...AppointmentDateEvent];
    const filteredIndex = AppointmentH.findIndex(
      x => x.title === `WO:${ReceiptNo}`
    );
    if (filteredIndex != -1) {
      AppointmentH.splice(filteredIndex, 1);
      AppointmentH.push({
        title: `WO:${ReceiptNo}`,
        start: new Date(SonlandirData[0].AppointmentDate),
        end: new Date(DateValue)
      });
    }
    else {
      AppointmentH.push({
        title: `WO:${ReceiptNo}`,
        start: new Date(SonlandirData[0].AppointmentDate),
        end: new Date(DateValue)
      });
    }

    setAppointmentDateEvent(AppointmentH);
    setTask(job);
  };




  const handleClickschedulingOpen = (event) => {
    axios.get(`/GetServiceShopScheduling/${ServiceShopId}`)
      .then((response) => {
        const Deger = response.data;
        if (Deger.length > 0) {
          setSchedulingData(Deger);
        } else {
          var Control = [{ AppointmentDate: 'no appointment', WorkOrderCount: 0 }];
          setSchedulingData(Control);
        }
      }).catch((error) => {

      });
    
    axios.get(`/GetTechnicianScheduling/${EmployeeId}`)
    .then((response) => {
      const Deger = response.data;
      if (Deger.length > 0) {
        setTechnicianSchedulingData(Deger);
      } else {
        var Control = [{ AppointmentDate: 'No appointment', WorkOrderCount: 0 }];
        setTechnicianSchedulingData(Control);
      }
    }).catch((error) => {

    });
    
    setSchedulingPopup(true);
  }
  const handlePotentialLiabiltiy = event => {
    event.persist();
    setAllAgent(event.target.checked);
    if(event.target.checked==true){
    GetAllSchedulingServiceShop();
    }
    else{
      GetSchedulingServiceShop(SonlandirData[0].ConsumerId,
        SonlandirData[0].ConsumerAddressId);


    }
  };
  function setToNoAppointmentDate() {
    if (!noAppointmentDate) {
      const AppointmentH = [...AppointmentDateEvent];
      const filteredIndex = AppointmentH.findIndex(
        x => x.title === `WO:${ReceiptNo}`
      );
      let job = SonlandirData[0];
      job = {
        ...job,
        AppointmentDate: null,
        AppointmentEndDate: null
      };
      if (filteredIndex !== -1) {
        AppointmentH.splice(filteredIndex, 1);
        setAppointmentDateEvent(AppointmentH);
        setTask(job);
      }
    }
    setNoAppointmentDate(!noAppointmentDate)
  }

  function eventStyleGetter(event) {
    var backgroundColor = '#19a3ff'

    if (event.MobileStatusId && event.MobileStatusId > 0) {
      if (event.MobileStatusId === 5) {
        backgroundColor = '#bf261b'
      }
      else if (event.MobileStatusId === 22) {
        backgroundColor = '#9615d1'
      }
      else if (event.MobileStatusId === 33) {
        backgroundColor = '#18c718'
      }
      else if (event.MobileStatusId === 42) {
        backgroundColor = '#ff9500'
      }
      else {
        backgroundColor = '#8c8c8c'
      }
    }


    var style = {
      backgroundColor: backgroundColor,
      borderRadius: '0px',
      opacity: 0.8,
      color: 'white',
      border: '0px',
      display: 'block'
    };
    return {
      style: style
    };
  }

  const GetTechnicianMap = (DateParam) => {
    setLoading(true);
    axios.get(`GetTechnicianMap/${ServiceShopId}/${EmployeeId}/${DateParam}`)
      .then((response) => {
        const ResponseData = response.data;
        if (ResponseData.length > 0) {
          setTechnicianMapData(ResponseData);
        } else {
          setTechnicianMapData([]);
        }
        setLoading(false);
      }).catch((error) => {
        setLoading(false);
      });

  }

  const handleClickschedulingOpenMap = (event) => {
    const Date = moment().format('DD.MM.yyyy');
    setMapDate(Date);
    GetTechnicianMap(Date);
    setSchedulingMapPopup(true);
  }


  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = 14;

  const handleNext = () => {
    var activeStepParam = activeStep + 1;
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    const Date = moment().add(activeStepParam, 'days').format('DD.MM.yyyy');
    setMapDate(Date);
    GetTechnicianMap(Date);
  };

  const handleBack = () => {
    var activeStepParam = activeStep - 1;
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    const Date = moment().add(activeStepParam, 'days').format('DD.MM.yyyy');
    setMapDate(Date);
    GetTechnicianMap(Date);
  };
  const theme = useTheme();

  const ToaControl = () => {
    var data = SonlandirData[0];

    if (!data) {
        return false; 
    }
    
    const hasValidAddresses = Array.isArray(data.Addresses) 
                              && data.Addresses.length > 0;
    const hasValidIssueId = data.IssueId !== null 
                            && data.IssueId !== undefined 
                            && data.IssueId !== 0;
    const hasValidConsumerId = data.ConsumerId !== null 
                                && data.ConsumerId !== undefined 
                                && data.ConsumerId !== 0;
    const hasValidConsumerAddressId = data.ConsumerAddressId !== null 
                                      && data.ConsumerAddressId !== undefined 
                                      && data.ConsumerAddressId !== 0 

    return hasValidIssueId && hasValidConsumerId && hasValidAddresses && hasValidConsumerAddressId;
  }

  const handleToaAssignment = () => {
    if (ToaControl()){
      setLoading(true);
      try {
        axios.get(`/GetTokenAndGuid/${ReceiptNo}`)
          .then((response) => {
            const ResponseData = response.data[0];
            var workOrderGuid = ResponseData.workGuid
            var sessionToken = ResponseData.SessionToken
            window.open(`http://contacttest.beko.com/GlobalScheduling/CallCenter/Index?culture=en-UK&WorkGuid=${workOrderGuid}&App=1&SessionToken=${sessionToken}&CountryId=17`, '_blank');
            setLoading(false);
          }).catch((error) => {
            setLoading(false);
          });
      } catch (error) {
          console.error('Error fetching data:', error);
      }
    }else{
      setUyariTip('warning');
      setOpen(true);
      setUyari1(t('lblToaControlMsg'));
    }
  }

  return (
    <Card className={classes.cardsMax}>
      <Backdrop className={classes.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <CardHeader title={t('lblScheduling')} />
      <Divider />
      <CardContent className={classes.content}>
        <div className={classes.fields}>
          <FormControl variant="outlined" className={classes.formControl}>
            <TextField
              size="small"
              fullWidth
              select
              label={t('lblAddress')}
              id="WorkOrderAddressId"
              onChange={handleChangeWorkOrderAddressId}
              value={ConsumerAddressId}
              variant="outlined"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Box display="flex" flexDirection="column" alignItems="center" onMouseDown={handleCopyMouseDown}>
                      <IconButton
                        aria-label="Copy address"
                        disabled={!selectedAddressText}
                        onClick={handleCopyAddress}
                        size="small"
                      >
                        <FileCopyIcon fontSize="small" />
                      </IconButton>
                      <Typography variant="caption">Copy</Typography>
                    </Box>
                  </InputAdornment>
                )
              }}
            >
              {SonlandirData[0]?.Addresses ? SonlandirData[0].Addresses.map(p => {
                return (
                  <MenuItem key={p.AddressId} value={p.AddressId}>
                    {p.Address}
                    {p.PrimaryAddress === true ? ` - ${t('lblPrimary')}` : ''}
                  </MenuItem>
                );
              }) : null}
            </TextField>
          </FormControl>
        </div>
        <div className={classes.fields}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={1} lg={1}>
                <FormControlLabel
                  control={
                  <Switch
                  color="primary"
                  disabled={!DisabledCanSeeAllagents}
                  checked={AllAgent}
                  onChange={handlePotentialLiabiltiy}
                  name="UrgentCustomer"
                />
                }
              label={t('All')}
              />
            </Grid>
            <Grid item xs={12} sm={4} lg={4}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  className={classes.formControl}
                >
                  <Autocomplete
                    size="small"
                    fullWidth
                    autoSelect
                    disableClearable
                    disabled={DisabledControl}
                    value={ServiceShopSelected || null}
                    options={ServiceShopData || []}
                    getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                    getOptionSelected={(option, value) => option.Id === value.Id}
                    renderInput={(params) => <TextField {...params} label={t('lblServiceShop')} variant="outlined"
                    />}
                    onChange={(event, value) => { handleChangeServiceShopId(value); }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={5} lg={5}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  className={classes.formControl}
                >
                  <Autocomplete
                    size="small"
                    fullWidth
                    autoSelect
                    value={EmployeeData.find(p => parseInt(p.Id) === parseInt(EmployeeId)) || null}
                    options={EmployeeData || []}
                    getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                    getOptionSelected={(option, value) => option.Id === value.Id}
                    renderInput={(params) => <TextField {...params} label={t('lblEmployee')} variant="outlined"
                    />}
                    onChange={(event, value) => { handleChangeEmployeeId(value); }}
                  />
                </FormControl>
              </Grid> 
              {SessionUser.TenantId === 16 ?
              <Grid item xs={12} sm={2} lg={2}>
                <Button 
                  color="primary" 
                  variant="contained" 
                  onClick={handleToaAssignment} 
                  startIcon={<CallMadeIcon />} 
                  style={{ textTransform: 'none'}}
                >
                  {t('lblAvailability')}
                </Button>
              </Grid> : ''}
          </Grid>
        </div>
        <div className={classes.fields}>
          <Grid container spacing={1} style={{marginTop:'25px'}}>
          <Grid item xs={12} sm={4} lg={4}>
            <FormControl fullWidth variant="outlined" className={classes.formControl}>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={localeMap[locale]}
              >
                <KeyboardDateTimePicker
                  color="primary"
                  fullWidth
                  size="small"
                  ampm={false}
                  inputVariant="outlined"
                  id="PreferredDate"
                  // disablePast
                  label={t('lblPreferredDate')}
                  invalidDateMessage={t('hatali_tarih')}
                  format="dd.MM.yyyy HH.mm"
                  variant="outlined"
                  value={
                    SonlandirData[0]?.PreferredDate ? SonlandirData[0].PreferredDate : ''
                  }
                  onChange={e => setPreferredDate(e)}
                  disabled={SessionUser.Role === 3 ? false : true}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </FormControl>
          </Grid>
          <Grid item xs={12} sm={4} lg={4}>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={localeMap[locale]}
              >
                <KeyboardDateTimePicker
                  color="primary"
                  fullWidth
                  size="small"
                  disabled={noAppointmentDate || SonlandirData[0].MobileStatusId == 42}
                  ampm={false}
                  inputVariant="outlined"
                  label={t('AppointmentDate')}
                  invalidDateMessage={t('hatali_tarih')}
                  format="dd.MM.yyyy HH.mm"
                  variant="outlined"
                  value={
                    SonlandirData[0]?.AppointmentDate ? SonlandirData[0].AppointmentDate : null
                  }
                  onChange={e => setAppointmentData(e)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </Grid>
          
          <Grid item xs={12} sm={3} lg={3} align={'center'}>
            <FormControl component="fieldset">
              <FormGroup aria-label="position" row>
                <FormControlLabel
                  control={<Checkbox color="primary"
                    checked={noAppointmentDate}
                    onChange={() => setToNoAppointmentDate()}
                  />}
                  label={t("lblNoAppointmentDate")}
                  labelPlacement="end"
                  checked={noAppointmentDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={1} lg={1} align={'center'}>
            <Box p={0}>
              <IconButton color="primary"
                onClick={(event) => handleClickschedulingOpen(event)} className={classes.info}>
                <EventNoteIcon />
              </IconButton>
            </Box>
          </Grid>
          </Grid>
        </div>
        <br />
        <Calendar
          selectable
          onSelectEvent={event => alert(event.title)}
          localizer={localizer}
          messages={messages}
          events={AppointmentDateEvent}
          defaultView={Views.WEEK}
          toolbar
          step={60}
          min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 8, 0)}
          style={{ height: 400 }}
          onSelectSlot={changeAppointmentDate}
          eventPropGetter={eventStyleGetter}
        />
      </CardContent>
      <Dialog
        open={SchedulingPopup}
        onClose={() => setSchedulingPopup(false)}
        fullWidth={true}
        maxWidth={'sm'}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblScheduling')}</DialogTitle>
        <br></br>
        <Divider></Divider>
        <br></br>
        <Grid container spacing={1}>
          <Grid item xs={1} sm={1} lg={1} />
          <Grid item xs={5} sm={5} lg={5}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => setServiceShopCapacitySelected(true)}
              style={ServiceShopCapacitySelected ? { backgroundColor: '#13d426' } : {}}
            >
              {t('lblService')}
            </Button>
          </Grid>
          <Grid item xs={5} sm={5} lg={5}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => setServiceShopCapacitySelected(false)}
              style={!ServiceShopCapacitySelected ? { backgroundColor: '#13d426' } : {}}
            >
              {t('lblTechnician')}
            </Button>
          </Grid>
          <Grid item xs={1} sm={1} lg={1} />
          <Divider></Divider>
        </Grid>
        <br></br>
        {
          ServiceShopCapacitySelected ?
            <DialogContent>
              {SchedulingData.map((row, index) => (
                <Card>
                  <CardHeader
                    title={moment(row.AppointmentDate).format('DD/MM/YYYY')}
                    subheader={<Typography variant="h6">
                      {t('lblTotalWork') + ' : ' + row.WorkOrderCount}
                    </Typography>}
                  />
                  <CardContent>
                    <Table
                      stickyHeader
                      aria-labelledby="tableTitle"
                      size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">
                            {t('lblTimeSlot')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblCapacity')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblWorkCount')}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row?.TimeSlotCapacity?.map((item, index) => (
                          <TableRow key={item.index}
                            style={{
                              backgroundColor:
                                item?.WorkCount > item.Capacity ? 'tomato' :
                                  (item?.WorkCount === item.Capacity ? '#AFEEEE' :
                                    '#CCFFCC')
                            }}
                          >
                            <TableCell align="left">
                              {item.TimeSlot}
                            </TableCell>
                            <TableCell align="left">
                              {item.Capacity}
                            </TableCell>
                            <TableCell align="left">
                              {item?.WorkCount}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
              ))}
            </DialogContent> :
            <DialogContent>
              {TechnicianSchedulingData.map((row, index) => (
                <Card>
                  <CardHeader
                    title={moment(row.AppointmentDate).format('DD/MM/YYYY')}
                    subheader={<Typography variant="h6">
                      {t('lblTotalWork') + ' : ' + row.WorkOrderCount}
                    </Typography>}
                  />
                  <CardContent>
                    <Table
                      stickyHeader
                      aria-labelledby="tableTitle"
                      size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">
                            {t('lblTimeSlot')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblCapacity')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblWorkCount')}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row?.TimeSlotCapacity?.map((item, index) => (
                          <TableRow key={item.index}
                            style={{
                              backgroundColor:
                                item?.WorkCount > item.Capacity ? 'tomato' :
                                  (item?.WorkCount === item.Capacity ? '#AFEEEE' :
                                    '#CCFFCC')
                            }}
                          >
                            <TableCell align="left">
                              {item.TimeSlot}
                            </TableCell>
                            <TableCell align="left">
                              {item.Capacity}
                            </TableCell>
                            <TableCell align="left">
                              {item?.WorkCount}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </CardContent>
                </Card>
              ))}
            </DialogContent>

        }

        <DialogActions>
          <Button
            onClick={() => setSchedulingPopup(false)}
            color="primary"
          >
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={SchedulingMapPopup}
        onClose={() => setSchedulingMapPopup(false)}
        fullWidth={true}
        maxWidth={'xl'}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Backdrop className={classes.backdrop} open={Loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <DialogTitle>
          <Typography variant="h6" component="h2" gutterBottom>
            {t('lblAppointmentDate') + ' : ' + MapDate}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={8} sm={8} lg={8}>
              <LoadScript googleMapsApiKey="AIzaSyBX1z5nvjcjzyxSMT-QCVS3ERu6Y3iNSb0">
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={TechnicianMapData.filter(x => x.LocationType === 1)[0]}
                  zoom={16}
                >

                  {TechnicianMapData.filter(x => x.lat > 0).map(item => (
                    <Marker
                      icon={item.LocationType === 1 ? 'http://maps.google.com/mapfiles/kml/paddle/go.png' : 'http://maps.google.com/mapfiles/kml/paddle/C.png'}
                      position={item}
                      title={item.LocationType === 1 ? 'Technician is here.' : 'WorkOrder : ' + item.WorkOrderId + ' - ' + item.Address}
                    />
                  ))}

                  <Polyline path={TechnicianMapData.filter(x => x.lat > 0)} />
                  <TrafficLayer />

                </GoogleMap>
              </LoadScript>
            </Grid>
            <Grid item xs={4} sm={4} lg={4}>
              <MobileStepper
                steps={maxSteps}
                alternativeLabel
                position="static"
                variant="text"

                activeStep={activeStep}
                nextButton={
                  <Button
                    size="small"
                    onClick={handleNext}
                    disabled={activeStep === maxSteps - 1}
                  >
                    Next
                    {theme.direction === "rtl" ? (
                      <KeyboardArrowLeft />
                    ) : (
                      <KeyboardArrowRight />
                    )}
                  </Button>
                }
                backButton={
                  <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                    {theme.direction === "rtl" ? (
                      <KeyboardArrowRight />
                    ) : (
                      <KeyboardArrowLeft />
                    )}
                    Back
                  </Button>
                }
              />

              <Paper elevation={1} style={{ maxHeight: 600, overflow: 'auto' }}>
                <List className={classes.root}>
                  {TechnicianMapData.map(item => (
                    <div key={item.WorkOrderId}>
                      <ListItem alignItems="flex-start">
                        <ListItemText
                          primary=""
                          secondary={(
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="body1"
                                className={classes.inline}
                                color="textPrimary"
                              >
                                <b>{t('WO')}:</b> {item.WorkOrderId}
                                <br></br>
                                <b>{t('Address')}:</b> {item.Address}
                                <br></br>
                                <b>{t('Longitude')}:</b> {item.lng}
                                <br></br>
                                <b>{t('Latitude')}:</b> {item.lat}
                              </Typography>
                            </React.Fragment>
                          )}
                        />
                      </ListItem>
                      <Divider />
                    </div>
                  ))}
                </List>
              </Paper>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setSchedulingMapPopup(false)}
            color="primary"
          >
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('Bilgilendirme')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari1}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        autoHideDuration={3000}
        ContentProps={{
          style: { backgroundColor: copySnackbarType === 'success' ? '#43a047' : '#d32f2f', color: '#fff' }
        }}
        message={copySnackbarMessage}
        onClose={() => setCopySnackbarOpen(false)}
        open={copySnackbarOpen}
      />

    </Card>
  );
}

Scheduling.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({
    tasks: state.tasks1
  }),
  { setTask }
)(Scheduling);
